import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useStore = create(persist(
  () => ({
    dueTime: null,
  }),
  {
    name: 'XeroSyncDueTime'
  }
))

export const setDueTime = (dueTime: string | null) => {
  useStore.setState(() => {
    return ({
      dueTime
    })
  })
}
